import http from '@/services/http'
import local from '@/local'
import logger from '@/services/logger'
import translation from '@/services/translation'
import { AuthBase } from 'shared'
import storage from '@/services/storage'
import taber from '@/services/taber'

class Auth extends AuthBase {
  _loginRoute () {
    return translation.route({
      name: 'home'
    })
  }

  async login (email, password) {
    try {
      // Send
      const resp = await this.sendWithApiKey({
        method: 'post',
        url: '/v1/auth/login',
        data: {
          email: email,
          password: password
        }
      })

      // Login
      super.login(resp.data.auth.access_token, resp.data.auth.refresh_token, resp.data.user, this._loginRoute())
    } catch (err) {
      return Promise.reject(err)
    }
  }

  loginAs (accessToken, user, redirect) {
    var r = null
    if (redirect) r = {}
    super.login(accessToken, null, user, r)
  }

  _logout (clearStorage, propagate, route) {
    // Get route
    if (!route) route = translation.route({ name: 'home' })

    // Logout
    super.logout(clearStorage, propagate, route)
  }

  async forgot (email) {
    try {
      // Send
      const resp = await this.sendWithApiKey({
        method: 'post',
        url: '/v1/auth/forgot',
        data: {
          email: email
        }
      })

      // Handle resp
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async reset (token, password) {
    try {
      // Send
      const resp = await this.sendWithApiKey({
        method: 'post',
        url: '/v1/auth/reset',
        data: {
          password: password,
          token: token
        }
      })

      // Handle resp
      return resp.data.message
    } catch (err) {
      return Promise.reject(err)
    }
  }

  _sendEvent (data) {
    data.baseURL = this.eventBaseURL
    return this.sendWithToken(data)
  }

  setEventBaseURL (u) {
    this.eventBaseURL = u
  }
}

export default new Auth(local.api_key, http, storage, taber, translation.route({ name: 'login' }), logger)
